var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredeterminada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 899,
    viewBox: "0 0 601 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600.662,
    height: 898.991,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.986 382.562L415.496 383.412H415.987V516.537H415.396L300.494 582.876L185.593 516.537H185V383.412H185.491L185.001 382.562L300.29 316L300.493 316.352L300.696 316L415.986 382.562ZM215.011 399.889V498.868L300.493 548.222L385.977 498.868V399.89L315.5 359.2V468.938H285.489V359.198L215.011 399.889ZM355.377 392.736V504.3H355.284L355.457 504.6L300.493 536.333L300.45 536.26L300.407 536.336L245.443 504.603L274.517 486.735L300.447 501.706L325.532 487.223V376.611L355.377 392.736Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 549.5,
    y1: -0.0000128835,
    x2: 26.5,
    y2: 886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8533FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredeterminada);
export default __webpack_public_path__ + "static/media/predeterminada.694a75a912d1d01862c61bf837f0c195.svg";
export { ForwardRef as ReactComponent };